import React from 'react';
import { DatePicker, Button, Space, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { useDateRange } from '../../contexts/DateRangeContext';
import './GlobalDateRangePicker.css';
import moment from 'moment';
import 'moment-timezone';
import { TZ } from '../../utils/tz';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const GlobalDateRangePicker = ({ showQuickButtons = true, size = 'default' }) => {
  const { dateRange, updateDateRange, setQuickRange } = useDateRange();

  const handleDateChange = (dates) => {
    if (!dates || !Array.isArray(dates) || dates.length !== 2) {
      console.warn('⚠️ [CALENDAR] handleDateChange: неверный формат дат', dates);
      return;
    }
    
    // Нормализуем к Asia/Qyzylorda
    const [s, e] = dates;
    if (!s || !e) {
      console.warn('⚠️ [CALENDAR] handleDateChange: отсутствуют начальная или конечная дата');
      return;
    }
    
    const startNormalized = moment.tz(s, TZ);
    const endNormalized = moment.tz(e, TZ);
    
    // Логирование изменения через календарь
    const startTz = startNormalized.clone().startOf('day');
    const endTz = endNormalized.clone().endOf('day');
    const daysDiff = endTz.diff(startTz, 'days');
    
    console.log('📆 [CALENDAR] handleDateChange вызван:', {
      source: 'calendar_picker',
      timezone: TZ,
      rawInput: {
        start: s.format ? s.format('YYYY-MM-DD HH:mm:ss') : String(s),
        end: e.format ? e.format('YYYY-MM-DD HH:mm:ss') : String(e)
      },
      normalized: {
        startLocal: startTz.format('YYYY-MM-DD HH:mm:ss'),
        endLocal: endTz.format('YYYY-MM-DD HH:mm:ss'),
        startISO: startTz.toISOString(),
        endISO: endTz.toISOString()
      },
      periodInfo: {
        startDate: startTz.format('YYYY-MM-DD'),
        endDate: endTz.format('YYYY-MM-DD'),
        daysDiff: daysDiff + 1
      }
    });
    
    updateDateRange([startNormalized, endNormalized]);
  };

  const quickButtons = [
    { key: 'today', label: 'Сегодня', type: 'today' },
    { key: 'yesterday', label: 'Вчера', type: 'yesterday' },
    { key: 'week', label: 'Неделя', type: 'week' },
    { key: 'month', label: 'Месяц', type: 'month' },
    { key: 'lastMonth', label: 'Прошлый месяц', type: 'lastMonth' },
  ];

  return (
    <div className="global-date-range-picker">
      <Space size="middle" wrap>
        <Space>
          <CalendarOutlined style={{ color: '#1890ff' }} />
          <Text strong>Период:</Text>
        </Space>
        
        <RangePicker
          value={dateRange}
          onChange={handleDateChange}
          format="DD.MM.YYYY"
          size={size}
          placeholder={['Дата начала', 'Дата окончания']}
          allowClear={false}
          style={{ minWidth: 240 }}
        />

        {showQuickButtons && (
          <Space wrap>
            {quickButtons.map(button => (
              <Button
                key={button.key}
                size={size}
                onClick={() => {
                  console.log('🔘 [BUTTON] Нажата кнопка быстрого выбора:', {
                    type: button.type,
                    label: button.label,
                    timezone: moment.tz(TZ).format('Z')
                  });
                  setQuickRange(button.type);
                }}
                type="default"
              >
                {button.label}
              </Button>
            ))}
          </Space>
        )}
      </Space>
    </div>
  );
};

export default GlobalDateRangePicker;
